module.exports = __webpack_public_path__ + "img/fourday_ps_11.0767cfda.jpg";